// extracted by mini-css-extract-plugin
export default {"form":"ForgotPassword_form__XhZRT","title":"ForgotPassword_title__qhtzd","button":"ForgotPassword_button__SIh4D"};